import { safeLocalStorage } from '@fluidx/utilities';
import { OdspDriverManifestCacheEntry } from './OdspDriverManifestAccessors';
import { OdspDriverManifest, OdspDriverManifestEnvironment } from './OdspDriverManifestType';

const OdspDriverManifestCacheStorageKeyPrefix = 'fluidOdspDriverManifestCache_';

export function getCachedManifestEntryForEnvironment(
  environment: OdspDriverManifestEnvironment
): OdspDriverManifestCacheEntry | null {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache
  const cacheEntry = safeLocalStorage()?.getItem(getCacheKey(environment));
  if (!cacheEntry) {
    return null;
  }

  const parsed: OdspDriverManifestCacheEntry = JSON.parse(cacheEntry);
  return parsed;
}

export function cacheManifestEntryForEnvironment(
  manifest: OdspDriverManifest,
  environment: OdspDriverManifestEnvironment
): void {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache
  const storage = safeLocalStorage();
  if (!storage) {
    return;
  }

  const manifestWithLastUpdatedTimestamp: OdspDriverManifestCacheEntry = { ...manifest, lastUpdatedTime: Date.now() };

  safeLocalStorage()?.setItem(getCacheKey(environment), JSON.stringify(manifestWithLastUpdatedTimestamp));
}

/**
 * Checks whether ODSP driver caching is enabled
 **/
export function isManifestCachingMechanismEnabled(): boolean {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache
  return !!safeLocalStorage();
}

function getCacheKey(environment: OdspDriverManifestEnvironment): string {
  const environmentOrDefault: Exclude<typeof environment, undefined> = environment || 'Prod';
  return OdspDriverManifestCacheStorageKeyPrefix + environmentOrDefault;
}
